module.exports = __webpack_public_path__ + "static/media/boston-solar.84459729.png";